export default {
    subject: '',
    name: '',
    division: '',
    descriptionLabel: '',
    description: '',
};
